import * as React from 'react';
import { CnPopover } from '@/components/cn-popover';
import { CnBox } from '@/components/cn-box';
const SingleUser = (props) => {
    const { user } = props;
    if (typeof user === 'object') {
        let nameDom;
        let nickNameDom;
        let workNoDom;
        const { name, nickName, workNo } = user;
        if (name)
            nameDom = name;
        if (nickName)
            nickNameDom = `(${nickName})`;
        if (workNo)
            workNoDom = workNo;
        const dom = (React.createElement("div", { className: "cn-ui-m-card-items-format-user-item" },
            React.createElement("img", { src: `https://work.alibaba-inc.com/photo/${workNo}.32x32.jpg` }),
            React.createElement("span", null,
                nameDom,
                nickNameDom)));
        if (workNoDom) {
            return React.createElement(CnPopover, { content: workNoDom }, dom);
        }
        return dom;
    }
    return user;
};
export const FormatUser = (props) => {
    const { value } = props;
    if (Array.isArray(value)) {
        return (React.createElement(CnBox, { className: "cn-ui-m-card-items-format-user", wrap: true, direction: "row", spacing: 4 }, value.map((item) => (React.createElement("div", null,
            React.createElement(SingleUser, { user: item }))))));
    }
    return (React.createElement("div", { className: "cn-ui-m-card-items-format-user" },
        React.createElement(SingleUser, { user: value })));
};
